import React from 'react';

import { flagStyles } from '../settings';

const SvgSG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4704px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSG;
